/**
 * Location Edit Facebook Module
 *
 * @author Paige Ponzeka (pponzeka@yext.com)
 */
goog.module('yext.location.facebook.ViewController');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const assetselector = goog.require('yext.dam.assetselector');
const events = goog.require('yext.dam.assetselector.events');
const dialog = goog.require('yext.dialog');
const fileupload = goog.require('yext.fileupload');
const Constraints = goog.require('yext.image.Constraints');
const CancelDialog = goog.require('yext.scheduledupdates.dialog.CancelDialog');
const RescheduleDialog = goog.require('yext.scheduledupdates.dialog.RescheduleDialog');
const RevertDialog = goog.require('yext.scheduledupdates.dialog.RevertDialog');
const routes = goog.require('yext.storm.routes');
const logflownav = goog.require('yext.storm.logflownav');
const usage = goog.require('yext.dam.assetselector.usage');

/**
 * Constructor for the facebook photo field view controller
 *
 * @param {string} field The type of field this controller is for
 * @param {!jQuery} $viewSelector the view selector for the facebook photo
 * @constructor
 */
const ViewController = function(field, $viewSelector, isSuggestEditMode, $entityAddForm) {
  this.field = field;
  this.$entityAddForm = $entityAddForm;

  if (this.$entityAddForm) {
    this.$entityAddForm.find('input[name="field"][value="' + this.field + '"]').remove();
  }
  this.isSuggestEditMode = isSuggestEditMode;
  this.profileDate = yext.getUrlParams().date;

  if ($viewSelector) {
    this.$viewSelector = $viewSelector.find('.js-facebook-photo-fields');
    this.isSuggestedEditView = $viewSelector.hasClass('.js-suggested-content') || $viewSelector.hasClass('.js-original-content');
  } else {
    this.$viewSelector = $('.js-facebook-photo-fields');
  }

  if (field === 'location.facebook_cover_photo') {
    this.$photoContainer = this.$viewSelector.find('.fb-cover-photo');
    // if there's a cover photo, initialize repositioning
    if (this.$photoContainer.find('img').length) {
      this.initRepositioning();
    }
    this.bindRepositionPhoto();
    this.bindSaveReposition();
  } else if (field === 'location.facebook_profile_photo') {
    this.$photoContainer = this.$viewSelector.find('.fb-profile-picture');
  }
  this.$row = this.$photoContainer.closest('tr');
  this.isFutureEditMode = Boolean(this.$row.data('futureEditMode'));

  this.$errorField = this.$photoContainer.closest('.fb-photo-fields').find('.field-freeform-error');

  this.initGallery();
  this.bindAddPhoto();
  this.bindRemovePhoto();
  this.bindSelectFromGallery();
  this.bindScheduledUpdateActions();
};

/**
 * Binds clicking on reposition photo in change photo dropdown
 */
ViewController.prototype.bindRepositionPhoto = function() {
  var self = this;
  this.$photoContainer.on('click', '.js-reposition-facebook-photo', function(e) {
    self.enableReposition();
  });
};

/**
 * Binds user clicking add photo option when editing facebook photo
 */
ViewController.prototype.bindAddPhoto = function() {
  var self = this;
  this.$photoContainer.on('click', '.js-add-facebook-photo', function(e) {
    var $facebookPhoto = $(this);
    var $form = $facebookPhoto.closest('.js-fb-photo-wrapper').find('.js-add-facebook-photo-form');
    var save = $facebookPhoto.closest('.fb-photo-dropdown').data('save');

    e.stopPropagation();

    self.$errorField.text('');
    self.showAssetSelector($facebookPhoto);
    if (!self.$entityAddForm) {
      self.bindAssetSelector($form, save);
    } else {
      self.bindEntityAddPage();
    }
  });
};

/**
 * Binds user clicking add photo option when editing facebook photo
 */
ViewController.prototype.bindRemovePhoto = function() {
  var self = this;
  this.$photoContainer.on('click', '.js-remove-facebook-photo', function(e) {
    var $facebookPhoto = $(this);
    var $form = $facebookPhoto.closest('.js-fb-photo-wrapper').find('.js-add-facebook-photo-form');
    var save = $facebookPhoto.closest('.fb-photo-dropdown').data('save');

    e.stopPropagation();

    self.$errorField.text('');
    var data = {};
    data.photoUrl = '';

    self.updateForm($form, data, save);
    self.submitForm($form.serializeArray());
  });
};

/**
 * When on entity add page, don't auto-submit this field. Store values in the form
 * for submission with all fields.
 */
ViewController.prototype.bindEntityAddPage = function() {
  var self = this;
  $(assetselector.events).on('added.assetselector', function(e, asset) {
    var data = {};

    if (asset.croppedImage) {
      data.croppedImage = asset.croppedImage;
      data.croppedImageName = asset.file ? asset.file.name : asset.photoUrl;
    } else if (asset.photoUrl) {
      data.photoUrl = asset.photoUrl;
    } else if (asset.file) {
      data.file = asset.file;
    }
    self.updateEntityAddForm(data);
  });
};

/**
 * Put correct values in entity add form.
 */
ViewController.prototype.updateEntityAddForm = function(data) {
  this.$entityAddForm.find('input[name="' + this.field + '.croppedImage"]').remove();
  this.$entityAddForm.find('input[name="' + this.field + '.croppedImageName"]').remove();
  this.$entityAddForm.find('input[name="' + this.field + '.url"]').remove();
  this.$entityAddForm.find('input[name="field"][value="' + this.field + '"]').remove();
  if (data.croppedImage) {
    this.$entityAddForm.append('<input type="hidden" name="' + this.field + '.croppedImage" value="' + data.croppedImage + '">');
    this.$entityAddForm.append('<input type="hidden" name="' + this.field + '.croppedImageName" value="' + data.croppedImageName + '">');
  } else if (data.photoUrl) {
    this.$entityAddForm.append('<input type="hidden" name="' + this.field + '.url" value="' + data.photoUrl + '">');
  }
  this.$entityAddForm.append('<input type="hidden" name="field" value="' + this.field + '">');

  this.$photoContainer.find('.fb-picture-container').replaceWith(this.constructImage(data));
  this.$photoContainer.find('.fb-no-picture').replaceWith(this.constructImage(data));
};

/**
 * Construct dom to show image on entity add page.
 */
ViewController.prototype.constructImage = function(data) {
  const src = data.photoUrl || data.croppedImage || data.file;
  return $.parseHTML(`<div class="fb-picture-container editable"><img style="width: 100%;" src="${src}"></div>`);
};

/**
 * Binds callback after an asset is added from the photo upload dialog
 *
 * @param {!jQuery} $form Form to submit after uploading photo
 * @param {boolean} save Whether to save or not
 */
ViewController.prototype.bindAssetSelector = function($form, save) {
  var self = this;
  $(assetselector.events).on('added.assetselector', function(e, asset) {
    var data = {};
    if (asset.file && !asset.croppedImage) {
      self.updateForm($form, data, save);
      self.submitFormWithFile($form, asset);
      return;
    } else if (asset.croppedImage) {
      data.croppedImage = asset.croppedImage;
      data.croppedImageName = asset.file ? asset.file.name : asset.photoUrl;
    } else {
      data.photoUrl = asset.photoUrl;
    }

    self.updateForm($form, data, save);
    self.submitForm($form.serializeArray());
  });
};

/**
 * Submit form with file
 *
 * @param {!jQuery} $form Form to containing field data
 * @param {Asset} asset object from assetselector
 */
ViewController.prototype.submitFormWithFile = function($form, asset) {
  var self = this;
  var data = $form.serializeArray();

  fileupload.upload({
    files: [asset.file],
    fileInput: [asset.fileInput],
    data: data,
    dataType: 'json',
    done: function(result) {
      self.onDone(result);
    },
    error: function() {
      self.showErrorDialog();
    },
  });
};

/**
 * Show the error dialog with a standard error message
  */
ViewController.prototype.showErrorDialog = function() {
  dialog.showErrorDialog(yext.msg('Something went wrong when saving the field'));
};

/**
 * Show the asset selector for entering a photo URL or uploading a file
 *
 * @param {!jQuery} $facebookPhoto photo object
 */
ViewController.prototype.showAssetSelector = function($facebookPhoto) {
  var self = this;
  var constraints = new Constraints({
    'container': $facebookPhoto,
  });

  assetselector.show({
    type: assetselector.types.PHOTO,
    includeUsedAssets: false,
    isSuggestedEditMode: self.isSuggestEditMode,
    isFutureEditMode: self.isFutureEditMode,
    usageType: usage.forProfileFields(self.field),
  },
  self.field,
  undefined, // custom field id
  constraints.get(),
  );
};

/**
 * Clear and update form with photo data
 *
 * @param {!jQuery} $form Form to update
 * @param {!Object} data Facebook photo data
 * @param {boolean} save Whether this field should be saved
 */
ViewController.prototype.updateForm = function($form, data, save) {
  $form.find('[name=field]').val(this.field);
  $form.find('input[name="' + this.field + '.index"]').remove();
  $form.find('input[name="' + this.field + '.croppedImage"]').remove();
  $form.find('input[name="' + this.field + '.croppedImageName"]').remove();
  $form.find('input[name="' + this.field + '.timestamp"]').remove();
  $form.find('input[name="allLocations"]').remove();
  $form.append('<input type="hidden" name="' + this.field + '.index" value="0">');
  if (data.croppedImage) {
    $form.append('<input type="hidden" name="' + this.field + '.croppedImage" value="' + data.croppedImage + '">');
    $form.append('<input type="hidden" name="' + this.field + '.croppedImageName" value="' + data.croppedImageName + '">');
  } else if (typeof data.photoUrl !== 'undefined') {
    $form.append('<input type="hidden" name="' + this.field + '.url" value="' + data.photoUrl + '">');
  }
  $form.append(this.$photoContainer.find('input[name$=".timestamp"]').clone());
  $form.append(yext.location.facebook.getAllLocationsInputEl());

  if (!save || save === false) {
    $form.attr('action', routes.LocationEdit.updateFacebookView());
  }
};

/**
 * Function to handle after photo has been uploaded
 *
 * @param {!Object} data response data
 */
ViewController.prototype.onDone = function(result) {
  var self = this;

  // NOTE(mattjs) This reconciles Locations format with Entities format
  if (result.field) {
    result.html = result.field.html;
  }

  var metadata = result.metadata;
  if (result && result.error) {
    var $form = this.$photoContainer.closest('form');
    if ($form.length > 0) {
      window.onSaveError(this.$photoContainer.closest('form'), result);
    } else {
      // Supports old and new error formats + fallback
      if (yext.isString(result.error)) {
        dialog.showErrorDialog(result.error);
      } else if (yext.isObject(result.error)) {
        for (var key in result.error) {
          dialog.showErrorDialog(result.error[key]);
          break;
        }
      } else {
        this.showErrorDialog();
      }
    }
    return;
  } else if (result.isSuggestedEdit
    || (metadata && metadata.suggestedEditIds)
    || result.suggestedEditIds) {
    window.location.reload();
  } else if (result && result.newTemplateId) {
    window.onbeforeunload = null;
    window.location = routes.LocationEdit.template({'templateId': result.newTemplateId});
  } else if (result && result.nextUrl) {
    window.onbeforeunload = null;
    window.location = result.nextUrl;
  } else { // edit case
    var $intro = this.$photoContainer.parents('.fb-welcome, .log-fb-wrapper');
    var $html = $(result.html);

    var fieldClass = this.field === 'location.facebook_profile_photo' ? '.fb-profile-picture' : '.fb-cover-photo';

    if ($intro.length > 0 && $html.find('.all-locations').length > 0) {
      // We get an html response containing both the multi-loc and
      // single-loc versions.
      $intro.find('.fb-all-locations ' + fieldClass).html($html.find('.all-locations').html());
      $intro.find('.fb-single-location ' + fieldClass).html($html.find('.single-location').html());
    } else {
      this.$photoContainer.html(result.html);
    }
    this.$photoContainer.trigger('photosUpdated');
    if (this.field === 'location.facebook_cover_photo') {
      // we need to wait for the fb image to be loaded in order to reposition it
      // because it requires it's dimensions to do some of the calculations
      $('.fb-cover-photo img').on('load', function() {
        $('.cover-added-label').show().delay(2000).fadeOut();
        self.initRepositioning();
        self.enableReposition();
      });
    }
    if (result.stale) {
      var $errorContainer;
      if (this.isLocalOptimization(result)) {
        $errorContainer = $('#localOptimization');
      } else {
        $errorContainer = this.$photoContainer.parents('tr');
      }

      if ($errorContainer.length === 0 && this.$photoContainer.is('.graybox')) {
        // For intro flow, the error field is within $parentEl
        $errorContainer = this.$photoContainer;
      }
      $errorContainer.find('.field-display').click(); // re-open edit
      $errorContainer.find('.field-freeform-error')
        .text(yext.msg('Your changes could not be made because another user edited this field since you loaded this page. Please try again.')).show();
    } else if (this.isLocalOptimization(result)) {
      logflownav.enableNextInLogFlow();
    }
  }

  var isScheduledUpdate = result.hasScheduledUpdates || (metadata && metadata.hasScheduledUpdates);
  if (isScheduledUpdate) {
    if (result.minRevertDate) {
      // Show revert dialog for location profile
      RevertDialog(
        result.fieldIds,
        result.customFieldIds,
        result.minRevertDate);
    } else if (metadata && metadata.minRevertDate) {
      // Show for entities, which store the same info, but under metadata
      RevertDialog(
        null, // field ids
        null, // custom field ids
        metadata.minRevertDate,
        metadata.entityFieldIds);
    }
  }

  var showScheduledUpdateElements = Boolean(this.isFutureEditMode && isScheduledUpdate);
  this.toggleScheduledUpdateElements(showScheduledUpdateElements);
};


/**
 * Updates visibility of Scheduled Updates related UI elements for a field that has a Scheduled
 * Update.
 *
 * @param {boolean} show Whether to show or hide the scheduled update elements
 */
ViewController.prototype.toggleScheduledUpdateElements = function(show) {
  this.$row.find('.js-scheduled-update-label').toggle(show);
  this.$row.find('.js-scheduled-update-actions').toggle(show);
  this.$row.toggleClass('scheduled-updates-highlight', show);
};

ViewController.prototype.bindScheduledUpdateActions = function() {
  var self = this;
  this.$row.find('.js-cancel-scheduled-update').on('click', function(e) {
    var cancelDialog = new CancelDialog(self.profileDate, self.field, undefined);
    cancelDialog.show();
    e.stopPropagation();
  });

  this.$row.find('.js-reschedule-scheduled-update').on('click', function(e) {
    var rescheduleDialog = new RescheduleDialog(self.profileDate, self.field, undefined);
    rescheduleDialog.show();
    e.stopPropagation();
  });
};

/**
 * Handles submitting the photo form via ajax
 *
 * @param {!Object} data Form data to send with ajax
 */
ViewController.prototype.submitForm = function(data) {
  var self = this;
  $.ajax({
    data: data,
    type: 'POST',
    success: function(result) {
      self.onDone(fileupload.parseHtmlEncodedJson(result));
    },
  }).fail(function() {
    self.showErrorDialog();
  });
};

/**
 * Handles Cover Photo Reposition Interactions
 * Including dragging, save, and cancel
 *
 * The selectors are re-initialized each time because the photo DOM is replaced on save
 */
ViewController.prototype.initRepositioning = function() {
  this.$pictureContainer = this.$photoContainer.find('.fb-picture-container.facebookCover'); // aka "the mask"
  this.$coverPhoto = this.$pictureContainer.find('img');
  this.$repositionLabel = this.$pictureContainer.find('.reposition-label');
  this.$editButtons = this.$photoContainer.find('.edit-buttons');
  this.$repositionForm = this.$editButtons.find('form');
  this.$submit = this.$editButtons.find('.btn-action');
  this.$cancel = this.$editButtons.find('.reset');

  // Set the original positions of the cover photo
  this.defaultTop = this.$coverPhoto[0].offsetTop;
  this.defaultLeft = this.$coverPhoto[0].offsetLeft;

  // Adds an allLocations variable to the form based on if the user is editing
  // one or all photos in the intro flow
  this.$repositionForm.append(yext.location.facebook.getAllLocationsInputEl());

  this.bindCancelReposition();
};

ViewController.prototype.enableReposition = function() {
  this.$repositionLabel.show();
  this.bindPhotoDrag();
  this.bindLabelDrag();
};

ViewController.prototype.disableReposition = function() {
  this.$repositionLabel.hide();
  this.unbindPhotoDrag();
  this.unbindLabelDrag();
};

/**
 * Handle dragging/masking affect for the cover photo
 */
ViewController.prototype.bindPhotoDrag = function() {
  var self = this;
  // Set the max offsets the image can be dragged to
  var maxTop = this.$pictureContainer.height() - this.$coverPhoto.height();
  var maxLeft = this.$pictureContainer.width() - this.$coverPhoto.width();
  this.$photoContainer.addClass('reposition-state');
  this.$coverPhoto.draggable({
    disabled: false,
    drag: function(event, ui) {
      // {ui.position} returns the current img offset
      // +/- the mouse drag offset

      // Keep the drag within the boundaries
      if (ui.position.top > 0) {
        ui.position.top = 0;
      } else if (ui.position.top < maxTop) {
        ui.position.top = maxTop;
      }

      if (ui.position.left > 0) {
        ui.position.left = 0;
      } else if (ui.position.left < maxLeft) {
        ui.position.left = maxLeft;
      }

      self.$submit.removeAttr('disabled');
      self.$editButtons.show();
    },

    stop: function(event, ui) {
      var _$self = $(this);

      // Determine if there is offset
      var totalOffsetLeft = -maxLeft;
      var totalOffsetTop = -maxTop;
      var offsetLeftPct = (Math.abs(_$self[0].offsetLeft) / totalOffsetLeft) * 100;
      var offsetTopPct = (Math.abs(_$self[0].offsetTop) / totalOffsetTop) * 100;

      // If negative, also set to 0. This is possible when dragging the mouse outside.
      if (totalOffsetLeft <= 0) {
        offsetLeftPct = 0;
      }

      if (totalOffsetTop <= 0) {
        offsetTopPct = 0;
      }

      // Set our form values to the fb percentages
      $('#cover-offset-x')[0].value = offsetLeftPct;
      $('#cover-offset-y')[0].value = offsetTopPct;
      if (!self.$editButtons) {
        self.$photoContainer.find('[name="coverOffsetX"]').val(offsetLeftPct);
        self.$photoContainer.find('[name="coverOffsetY"]').val(offsetTopPct);
      }
    },
  });
};

// Forward any "drag" events from the label to the image behind it
// This is fixes an overlay issue of the label being above the image
ViewController.prototype.bindLabelDrag = function() {
  var self = this;
  this.$repositionLabel.bind('mousedown', function(e) {
    self.$coverPhoto.trigger(e);
  });
};

ViewController.prototype.unbindPhotoDrag = function() {
  this.$editButtons.addClass('disabled').hide();
  this.$coverPhoto.draggable('disable');
  $('.photo-field-display').removeClass('reposition-state');
};

ViewController.prototype.unbindLabelDrag = function() {
  this.$repositionLabel.hide().unbind('mousedown');
};

/**
 * Binds when clicking save after repositioning cover photo
 */
ViewController.prototype.bindSaveReposition = function() {
  var self = this;
  var $row = this.$photoContainer.closest('tr');

  this.$photoContainer.on('submit', '.js-facebook-reposition-form', function(e) {
    e.preventDefault();
    self.disableReposition();
    if (self.$submit.is(':disabled')) {
      return;
    }

    var form = this;
    $.ajax({type: 'POST',
      data: $(form).serializeArray(),
      success: function(result) {
        // NOTE(mattjs) This reconciles Locations format with Entities format
        if (result.field) {
          result.html = result.field.html;
        }

        // The profile service should not raise errors on a reposition.
        // However, something should be printed to avoid a silent failure.
        if (result.error) {
          dialog.showErrorDialog(yext.msg(
            'Your cover photo was not repositioned. Please re-upload this photo and try again.'));
          return;
        }
        if (result.stale) {
          dialog.showErrorDialog(yext.msg(
            'Your changes could not be made because another user edited this ' +
            'field since you loaded this page. Please try again.'));
          return;
        }
        if (result.isSuggestedEdit || (result.metadata && result.metadata.suggestedEditIds)) {
          window.location.reload();
        } else {
          self.$photoContainer.not(':hidden');
          var $intro = self.$photoContainer.parents('.fb-welcome, .log-fb-wrapper');
          var $html = $(result.html);
          if ($intro.length > 0 && $html.find('.all-locations').length > 0) {
            // We get an html response containing both the multi-loc and
            // single-loc versions.
            $intro.find('.fb-all-locations .fb-cover-photo').html($html.find('.all-locations').html());
            $intro.find('.fb-single-location .fb-cover-photo').html($html.find('.single-location').html());
          } else {
            self.$photoContainer.html(result.html);
          }
          self.initRepositioning();
          self.$photoContainer.trigger('photosUpdated');

          var showScheduledUpdateElements = Boolean(self.isFutureEditMode
              && (result.hasScheduledUpdates || (result.metadata && result.metadata.hasScheduledUpdates)));
          self.toggleScheduledUpdateElements(showScheduledUpdateElements);
        }
      },
      error: function() {
        self.showErrorDialog();
      }});
  });
};

ViewController.prototype.bindCancelReposition = function() {
  var self = this;
  self.$cancel.bind('click', function(e) {
    self.$coverPhoto.animate({
      left: self.defaultLeft,
      top: self.defaultTop,
    }, 200);

    self.disableReposition();
  });
};

/**
 * Creates a dialog for the user to select an image from the businesses
 * locations gallery and tries to display unique results.
 */
ViewController.prototype.initGallery = function() {
  this.$selectDialog = $('.select-photo-dialog-template').clone();
  this.$selectDialog.removeClass('select-photo-dialog-template').addClass('select-photo-dialog');
  this.$cancelBtn = this.$selectDialog.find('.cancel');
  this.$galleryForm = this.$selectDialog.find('form');

  // Initialize gallery
  // Keep a skeleton copy of our raw form
  if (!this.$galleryForm.data('original')) {
    this.$galleryForm.data('original', this.$galleryForm.html());
  }

  this.createDialog();
  this.bindPhotoSelect();
  this.bindCloseDialog();
};

/**
 * Handle the selection from the list of gallery images
 */
ViewController.prototype.bindPhotoSelect = function() {
  var self = this;

  // Delegate click handlers to deal with the asynchronous loading of images
  this.$selectDialog.delegate('.photo-image-wrapper', 'click', function() {
    var isModifyTemplate = $('.fb-template-modify').data('modify');
    var selectedImg = $(this).find('img')[0];
    var w = selectedImg.dataset.realwidth;
    var h = selectedImg.dataset.realheight;
    updateFormGalleryCoverPhoto(selectedImg.src, w, h);

    if (isModifyTemplate === true) {
      window.onFieldSave(self.$galleryForm, undefined, gallerySaveSuccess, undefined, undefined, true,
        routes.LocationEdit.updateFacebookView());
    } else {
      window.onFieldSave(self.$galleryForm, undefined, gallerySaveSuccess, undefined, undefined, true);
    }
  });

  var gallerySaveSuccess = function(data) {
    if (data.error) {
      dialog.showErrorDialog(data.error);
      return;
    }

    var newHtml;
    if (self.$photoContainer.parents('.fb-all-locations').size() > 0) {
      newHtml = $(data.html).find('.all-locations').html() || data.html;
    } else {
      newHtml = $(data.html).find('.single-location').html() || data.html;
    }
    self.$photoContainer.html(newHtml);

    // Handle the gallery response based on the field
    if (self.field == 'location.facebook_cover_photo') {
      $('.fb-cover-photo img').on('load', function() {
        self.initRepositioning();
        self.enableReposition();
      });
    }

    $('.fb-photo-fields').not(':hidden').trigger('photosUpdated');
    $('.select-photo-dialog').trigger('fbGallery.close');
  };

  /**
   * Updates our generic form to be field-specific
   * @param imgUrl {string|url} the image that was selected
   */
  var updateFormGalleryCoverPhoto = function(imgUrl, imgWidth, imgHeight) {
    // Since our forms are generic, we need to fetch the timestamp value
    // from our actual field that we're updating and copy it's value
    var timestamp = $('input[name="' + self.field + '.timestamp"]')[0].value;
    self.$galleryForm.find('.form-field')[0].value = self.field;
    self.$galleryForm.find('.form-timestamp').attr('name', self.field + '.timestamp')[0].value = timestamp;
    self.$galleryForm.find('.form-img-url').attr('name', self.field + '.url')[0].value = imgUrl;
    self.$galleryForm.find('.form-dimension-width').attr('name', self.field + '.width')[0].value = imgWidth;
    self.$galleryForm.find('.form-dimension-height').attr('name', self.field + '.height')[0].value = imgHeight;
    self.$galleryForm.append(yext.location.facebook.getAllLocationsInputEl());
  };
};

/**
 * Create the dialog and settings
 */
ViewController.prototype.createDialog = function() {
  var dialogTitle;
  if (this.field == 'location.facebook_cover_photo') {
    // TRANSLATORS: Title of dialog for adding a Facebook cover photo
    dialogTitle = yext.msg('Choose cover photo from your gallery');
  } else {
    // TRANSLATORS: Title of dialog for adding a Facebook profile photo
    dialogTitle = yext.msg('Choose profile picture from your gallery');
  }

  this.$selectDialog.dialog({
    title: dialogTitle,
    autoOpen: false,
    modal: true,
    draggable: false,
    resizable: false,
    closeOnEscape: true,
    dialogClass: this.dialogClass,
    width: '510',
    position: {
      my: 'center',
      at: 'center',
      of: window,
    },
  });
};

/**
 * Populate our dialog with the gallery selection via AJAX
 * and display it to the user
 */
ViewController.prototype.bindSelectFromGallery = function() {
  var self = this;
  this.$photoContainer.on('click', '.js-select-facebook-gallery', function(e) {
    var $dialogContent = self.$selectDialog.find('.dialog-content');
    // Build the new gallery DOM in memory instead of in view (performance perk)
    $dialogContent.detach().empty();

    var progressDialogId = dialog.showDelayedProgressDialog(yext.msg('Loading Photos...'));
    var templateId = $('[name="templateId"]').val();
    var getGalJson;
    if (templateId) {
      getGalJson = routes.LocationEdit.getTemplateGalleryJSON({
        'templateId': templateId,
      });
    } else {
      var ids = yext.getUrlParams().ids;
      if (!ids) {
        ids = (window.allLocationIds || []).join(','); // NOTE(robfig): hack for the LOG task
      }
      getGalJson = routes.LocationEdit.getGalleryJSON({
        'ids': ids,
      });
    }
    $.getJSON(getGalJson).done(function(data) {
      dialog.hideDelayedProgressDialog(progressDialogId);

      // TODO(billy) This is a quick fix to support an empty gallery.
      // Eventually we want to toggle the drop-down option to either show or hide depending on
      // if the user has gallery photos or not. That gets a little tricky when photos can
      // can grow and shrink dynamically, so we do this for now.
      if (!data.length || data.length === 0) {
        // TRANSLATORS: Gallery is the photo set for one or more locations. This message is being shown because the user is trying to browse an empty gallery.
        dialog.showErrorDialog(yext.msg('You don\'t have any photos in your gallery. Please add some and then try again.'));
        return false;
      }

      for (var i = 0; i < data.length; i ++) {
        $dialogContent.append('<div class="photo-image-wrapper">' +
                                 '<img src="' + data[i].url + '"' +
                                 'data-realwidth="' + data[i].width + '"' +
                                 'data-realheight="' + data[i].height + '">' +
                                 '</div>');
      }

      // Put our new DOM back into view and reposition incase of height change
      self.$selectDialog
        .dialog('open')
        .prepend($dialogContent)
        .dialog('option', 'position', {
          my: 'center',
          at: 'center',
          of: window,
        });
    }).fail(function(data) {
      dialog.hideDelayedProgressDialog(progressDialogId);
      // TRANSLATORS: Gallery is the photo set for one or more locations.
      dialog.showErrorDialog(yext.msg('There was an error loading your gallery. Please try again.'));
    });
  });
};

ViewController.prototype.bindCloseDialog = function() {
  var self = this;

  // Bind close dialog on save
  this.$selectDialog.on('fbGallery.close', function() {
    self.$galleryForm.html(self.$galleryForm.data('original'));
    self.$selectDialog.dialog('close');
  });

  // Cancel dialog handling
  this.$cancelBtn.bind('click', function() {
    self.$galleryForm.html(self.$galleryForm.data('original'));
    self.$selectDialog.dialog('close');
  });
};

/**
 * Checks to see if it's a single or multiloc update
 * NOTE: This is a duplicate method from OLD Uncoverted code
 *
 * @returns {node} hidden input element for allLocations
 */
yext.location.facebook.getAllLocationsInputEl = function() {
  return $('<input/>', {
    type: 'hidden',
    name: 'allLocations',
    value: $('#fb-view-dropdown').val() === 'business',
  },
  );
};

/**
 * NOTE: This is a duplicate method from OLD Uncoverted code
 *
 * @param {!Object} data
 */
ViewController.prototype.isLocalOptimization = function(data) {
  return typeof data != 'undefined' && typeof data.type != 'undefined' && data.type == 'localOptimization';
};

exports = ViewController;
